<template id="sortingoptions">
    <div class="my-2 mx-1" v-if="sneakerFilterOptionsData && isShowSneakerFilter">
      <div class="" id="sneaker">
          <div class="d-flex filter-options" v-if="sneakerFilterOptionsData[0]">
            <div class="filter-btn" v-for="(option, optionsIndex) in sneakerFilterOptionsData[0].options" :key="optionsIndex">
              <div class="btn-action" :class="option.slug === sneakerOptions[0] ? 'button-highlight' : ''" @click="sortHandler(option)">
                <div class="btn-content">
                  <img class="btn-img" :src="getImg(option, sneakerOptions[0])" alt="">
                  <span>{{option.name}}</span>
                  <img v-if="option.slug === sneakerOptions[0]" class="btn-img" src="https://prod-img.thesouledstore.com/static/x.svg" alt="">
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'sneaker-filter-options',
    props: ['sneakerOptions'],
    computed: {
      ...mapGetters(['bannerPlcaeHolderData']),
      sneakerFilterOptionsData () {
        const data = this.$parent.$refs.filterOptions.sneakerFilterOptionsData
        if (data && data[0] && Array.isArray(data[0].options)) {
          data[0].options = data[0].options.map(option => ({
            ...option,
            field: 'sneaker'
          }))
        }
        return data
      },
      applyEffect () {
        return this.$parent.$refs.filterOptions.sneakerValue[0]
      },
      isShowSneakerFilter: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_SNEAKER_FILTER_WEB'.toLowerCase())
      }
    },
    methods: {
      sortHandler (option) {
        if (option.slug === this.sneakerOptions[0]) {
          this.$parent.$refs.filterOptions.removeFilterChipHandler(option)
        } else {
          this.$parent.$refs.filterOptions.applySneakerFilter(option)
        }
      },
      getImg (option, applyEffect) {
        if (option.name === 'High Top') {
          if (option.slug === applyEffect) {
            return 'https://prod-img.thesouledstore.com/static/shoesHselected.svg'
          }
          return 'https://prod-img.thesouledstore.com/static/shoesH.svg'
        } else {
          if (option.slug === applyEffect) {
            return 'https://prod-img.thesouledstore.com/static/shoesLselected.svg'
          }
          return 'https://prod-img.thesouledstore.com/static/shoesL.svg'
        }
      }
    }
  }
  </script>
<style lang="css" scoped>
.filter-btn {
  width: 95%;
  margin: 0 10px;
}
.filter-options{
  justify-content: space-evenly;
}
.button-highlight {
  background: #187A7B;
  color: #fff;
}
.btn-action {
  height: 45px;
  border-radius: 22px;
  border: 1px solid #187A7B;
  padding: 9px 0 9px 0;
}
.btn-content {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  gap: 10px;
}
.btn-img {
  color: #fff;
}
</style>




// WEBPACK FOOTER //
// sneakerFilterOptions.vue?1e4d7abd